import { useEffect } from "react";
import { useNavigate } from "react-router-dom";



export default function MauiEventListener() {

    const navigate = useNavigate();

    useEffect(() => {

        const onRouteRequest = (e: Event) => {
            const route = (e as any)?.detail?.route;
            if (route) navigate(route, {
                replace: true
            });
        }

        window.addEventListener("rinvox-mauiapp-route-request", onRouteRequest);

        return () => {
            window.removeEventListener("rinvox-mauiapp-route-request", onRouteRequest);
        };

    }, [])

    return (<></>)
}